import { Box, Button, Paper, Stack } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { PageHeader } from 'src/ui/shell/PageHeader';
import { enterpriseDataGridSx } from 'src/ui/shell/enterpriseDataGridSx';

type AuditRow = {
  id: string;
  ts: string;
  actor: string;
  action: string;
  tenantId?: string;
  target?: string;
};

const columns: GridColDef<AuditRow>[] = [
  { field: 'ts', headerName: 'Timestamp', width: 200 },
  { field: 'actor', headerName: 'Actor', width: 180 },
  {
    field: 'action',
    headerName: 'Action',
    flex: 1,
    minWidth: 260,
    renderCell: ({ value }) => (
      <Box
        component="span"
        sx={{
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          fontSize: 12,
          fontWeight: 600,
          color: 'secondary.light',
        }}
      >
        {value}
      </Box>
    ),
  },
  { field: 'tenantId', headerName: 'Tenant', width: 140 },
  { field: 'target', headerName: 'Target', flex: 1, minWidth: 220 },
];

const rows: AuditRow[] = [
  {
    id: 'a1',
    ts: '2026-04-21T10:12:33Z',
    actor: 'superadmin',
    action: 'USER_DISABLE',
    tenantId: 'demo',
    target: 'support',
  },
  {
    id: 'a2',
    ts: '2026-04-21T10:05:11Z',
    actor: 'superadmin',
    action: 'TENANT_VIEW',
    tenantId: 'amn',
    target: 'amn',
  },
  {
    id: 'a3',
    ts: '2026-04-21T09:41:02Z',
    actor: 'superadmin',
    action: 'POLICY_PUBLISH',
    tenantId: 'acme-corp',
    target: 'default-bundle',
  },
];

export function AuditPage() {
  return (
    <Stack spacing={3}>
      <PageHeader
        eyebrow="Evidence"
        title="Audit log"
        description="Immutable trail of security-relevant changes. Stream from x-IAM audit topics or your SIEM."
        rightSlot={
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} width={{ xs: '100%', sm: 'auto' }}>
            <Button startIcon={<IosShareOutlinedIcon />} variant="outlined" color="inherit" disabled sx={{ fontWeight: 600 }}>
              Export CSV
            </Button>
            <Button startIcon={<RefreshOutlinedIcon />} variant="contained" disabled sx={{ fontWeight: 600 }}>
              Pull latest
            </Button>
          </Stack>
        }
      />

      <Paper sx={{ p: 0, overflow: 'hidden', borderRadius: 2 }}>
        <Box sx={{ height: 540, width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            disableRowSelectionOnClick
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 250 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10, page: 0 } },
            }}
            sx={enterpriseDataGridSx}
          />
        </Box>
      </Paper>
    </Stack>
  );
}
